import BaseAPI from '@/apis/base/baseApi';
export default class DashboardApi extends BaseAPI {
  apiName = 'Dashboard';
}
